import React from 'react';
import { Container } from '@si-armes/dsfr-react';
import FormulaireSupprimerArme from './components/FormulaireSupprimerArme';

const SupprimerArme = () => {
    return (
        <Container>
            <h1>Demande de suppression d&apos;arme(s) certifiée(s)</h1>
            <FormulaireSupprimerArme />
        </Container>
    );
};

export default SupprimerArme;
